export class MaskUtils {
    static cpfCnpj(value: string): string {
        if (!value) return '';
        value = value.replace(/\D/g, '');

        if (value.length > 14) value = value.substring(0, 14);

        if (value.length <= 11) {
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        } else {
        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d{1,2})$/, '$1-$2');
        }

        return value;
    }

    static cpf(value: string): string {
        if (!value) return '';

        value = value
        .replace(/\D/g, '')
        .substring(0, 11);

        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

        return value;
    }

    static cnpj(value: string): string {
        if (!value) return '';

        value = value
        .replace(/\D/g, '')
        .substring(0, 14);

        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d{1,2})$/, '$1-$2');

        return value;
    }

    static telefone(value: string): string {
        if (!value) return '';

        value = value
        .replace(/\D/g, '')
        .substring(0, 11);

        if (value.length <= 2) {
            return value.replace(/^(\d{0,2})/, '($1');
        }

        if (value.length <= 3) {
            return value.replace(/^(\d{2})(\d{0,1})/, '($1) $2');
        }

        if (value.length <= 7) {
            return value.replace(/^(\d{2})(\d{1})(\d{0,4})/, '($1) $2 $3');
        }

        return value.replace(/^(\d{2})(\d{1})(\d{4})(\d{0,4})/, '($1) $2 $3-$4');
    }


    static placaVeiculo(value: string): string {
        if (!value) return '';

        const valor = value
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, '');

        const letras = valor.slice(0, 3).replace(/[^A-Z]/g, '');

        if (letras.length < 3) {
            return letras;
        }

        const resto = valor.slice(3);

        if (!resto) {
            return letras;
        }

        const primeiro = resto[0] ?? '';
        const segundo = resto[1] ?? '';
        const terceiro = resto[2] ?? '';
        const quarto = resto[3] ?? '';

        if (!/\d/.test(primeiro)) {
            return letras;
        }

        if (!segundo) {
            return `${letras}${primeiro}`;
        }

        if (/\d/.test(segundo)) {
            const numeros = resto.replace(/\D/g, '').slice(0, 4);
            return `${letras}-${numeros}`;
        }

        if (/[A-Z]/.test(segundo)) {
            let placa = `${letras}${primeiro}${segundo}`;

            if (terceiro && /\d/.test(terceiro)) {
                placa += terceiro;
            }

            if (quarto && /\d/.test(quarto)) {
                placa += quarto;
            }

            return placa.slice(0, 7);
        }

        return `${letras}${primeiro}`;
    }

    static real(value: string | number): string {
        if (value === null || value === undefined || value === '') return '';

        let valor = value.toString().replace(/\D/g, '');

        if (!valor) return '';

        valor = (Number(valor) / 100).toFixed(2);

        return Number(valor).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
        });
    }

    static removerMascaraReal(value: string): number | null {
        if (!value) return null;

        const valorLimpo = value.replace(/\D/g, '');

        if (!valorLimpo) return null;

        return Number(valorLimpo) / 100;
    }

    static dolar(value: string | number): string {
        if (value === null || value === undefined || value === '') return '';

        let valor = value.toString().replace(/\D/g, '');

        if (!valor) return '';

        valor = (Number(valor) / 100).toFixed(2);

        return Number(valor).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
        });
    }

    static removerMascaraDolar(value: string): number | null {
        if (!value) return null;

        const valorLimpo = value.replace(/\D/g, '');

        if (!valorLimpo) return null;

        return Number(valorLimpo) / 100;
    }

    static container(value: string): string {
        if (!value) return '';

        value = value
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .substring(0, 11);

        const letras = value.substring(0, 4).replace(/[^A-Z]/g, '');
        const numeros = value.substring(4).replace(/\D/g, '');

        if (letras.length < 4) {
        return letras;
        }

        if (numeros.length <= 6) {
        return `${letras} ${numeros}`;
        }

        return `${letras} ${numeros.substring(0, 6)}-${numeros.substring(6, 7)}`;
    }
}